import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import useBusinessParam from '../../hooks/useBusiness';
import { Design, designBaseUrl } from '../../lib/FL';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import PreviewOverlay from '../atom/PreviewOverlay';
import NewCaption from '../atom/NewCaption';
import DesignPreviewModal from '../modal/DesignPreviewModal';

import styles from './DesignCard.module.scss';

type Props = {
  design: Design;
};

const DesignCard: React.FC<Props> = ({ design }) => {
  const business = useBusinessParam();
  const dispatch = useContext(ModalDispatchContext);
  const createPreviewModal = () => <DesignPreviewModal design={design} business={business} />;

  const CardContents: React.FC = () => (
    <>
      <div className={styles.thumbnail}>
        {design.is_new && <NewCaption />}
        <img
          src={`${designBaseUrl}/assets_resized/formatline/design/pc/type${design.type}/${business}_600_720.png`}
          alt={design.ja_name}
          className={styles.thumbnail__img}
        />
        <PreviewOverlay />
      </div>
      <h2 className={styles.card__title}>{design.ja_name}</h2>
    </>
  );

  const CardContentsWithLink: React.FC = () => (
    <>
      <button
        className={`${styles.card__button} ${styles.card__button_pc} onMouseShowPreviewOverlay`}
        type='button'
        onClick={() => dispatch(createPreviewModal)}
      >
        <CardContents />
      </button>
      <Link
        className={`${styles.card__button} ${styles.card__button_sp}`}
        to={`/type${design.type}/${business}.php`}
        target='_blank'
      >
        <CardContents />
      </Link>
    </>
  );

  return (
    <li className={styles.card}>
      <CardContentsWithLink />
    </li>
  );
};

export default DesignCard;
